import { Modal as AntModal } from "antd";

export const Modal = AntModal;
export type { ModalProps } from "antd";
